<div>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <h2 *ngIf="account">Password for [<strong>{{account.username}}</strong>]</h2>

            <div class="alert alert-success" *ngIf="success">
                <strong>Password changed!</strong>
            </div>
            <div class="alert alert-danger" *ngIf="error">
                <strong>An error has occurred!</strong> The password could not be changed.
            </div>

            <div class="alert alert-danger" *ngIf="doNotMatch">
                The password and its confirmation do not match!
            </div>

            <form name="form" role="form" (ngSubmit)="changePassword()" [formGroup]="passwordForm">

                <div class="form-group">
                    <label class="form-control-label" for="currentPassword">Current password</label>
                    <input type="password" class="form-control" id="currentPassword" name="currentPassword"
                           placeholder="{{'global.form.currentpassword.placeholder' | translate}}"
                           formControlName="currentPassword" autocomplete="off">
                    <div *ngIf="passwordForm.get('currentPassword').invalid && (passwordForm.get('currentPassword').dirty || passwordForm.get('currentPassword').touched)" >
                        <small class="form-text text-danger"
                               *ngIf="passwordForm.get('currentPassword').errors.required">
                            Your current password is required.
                        </small>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-control-label" for="newPassword">New password</label>
                    <input type="password" class="form-control" id="newPassword" name="newPassword"
                           placeholder="{{'global.form.newpassword.placeholder' | translate}}"
                           formControlName="newPassword">
                    <div *ngIf="passwordForm.get('newPassword').invalid && (passwordForm.get('newPassword').dirty || passwordForm.get('newPassword').touched)">
                        <small class="form-text text-danger"
                           *ngIf="passwordForm.get('newPassword').errors.required">
                            New password is required.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="passwordForm.get('newPassword').errors.minlength">
                            Your password is required to be at least 14 characters.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="passwordForm.get('newPassword').errors.maxlength">
                            Your password cannot be longer than 50 characters.
                        </small>
                    </div>
                    <jhi-password-strength-bar [passwordToCheck]="passwordForm.get('newPassword').value"></jhi-password-strength-bar>
                </div>
                <div class="form-group">
                    <label class="form-control-label" for="confirmPassword">New password confirmation</label>
                    <input type="password" class="form-control" id="confirmPassword" name="confirmPassword"
                           placeholder="{{'global.form.confirmpassword.placeholder' | translate}}"
                           formControlName="confirmPassword">
                    <div *ngIf="passwordForm.get('confirmPassword').invalid && (passwordForm.get('confirmPassword').dirty || passwordForm.get('confirmPassword').touched)">
                        <small class="form-text text-danger"
                           *ngIf="passwordForm.get('confirmPassword').errors.required">
                            Your confirmation password is required.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="passwordForm.get('confirmPassword').errors.minlength">
                            Your confirmation password is required to be at least 14 characters.
                        </small>
                        <small class="form-text text-danger"
                           *ngIf="passwordForm.get('confirmPassword').errors.maxlength">
                            Your confirmation password cannot be longer than 50 characters.
                        </small>
                    </div>
                </div>
                <button type="submit" [disabled]="passwordForm.invalid" class="btn btn-primary">Save</button>
            </form>
        </div>
    </div>
</div>
